import { Component, OnInit } from '@angular/core';
import { _HttpClient } from '@delon/theme';

@Component({
  selector: 'app-sucu01-data0020001',
  templateUrl: './sucu01-data0020001.component.html',
})
export class Sucu01Data0020001Component implements OnInit {

    constructor(
        private http: _HttpClient
    ) { }

    ngOnInit() {
    }

}
